import { React } from 'react';
import { format } from 'date-fns';

import HeaderAccount from './header-account/HeaderAccount';
import logo from '../../assets/images/SoleraLogo_TW.png';

import SoleraLogo from '../../assets/images/SoleraLogo_TB_Fast.png';

import config from '../../config/config.json';

import './Header.scss';

function Header(props) {

  const headerTitle = config.applicationTitle;

  let lastLogin;
  if (props.lastLogin) {
    lastLogin = format(Date.parse(props.lastLogin), 'dd/MM/yyyy');
  }

  return (
    <header id="pageHeader" className="header">
      <div className="header-container">
        <div className="header-title-container">
          <div className="header-logo">
                      <a href="/home" target="_blank" rel="noreferrer">
              <img className="logo-img" src={SoleraLogo} alt="not found" />
            </a>
          </div>
          <div className="header-title">
            {props.userAuthenticated ?
              <a href="/home">
                <h1>{headerTitle}</h1>
              </a> :
              <h1>{headerTitle}</h1>
            }
          </div>
        </div>
        {props.userAuthenticated ?
        <div className="last-login">
          <span><b>Last time you logged in: </b>{lastLogin}</span>
        </div>
        : <div></div>}
        {props.userAuthenticated ?
        <HeaderAccount env={props.env} subscriberDetails={props.subscriberDetails} />
        : <div></div>}
      </div>
    </header>
  );
}

export default Header;
